import template from './recommended-providers.html';
import { ENVIRONMENT } from '../../../environment';
import { ITEM_DEFINITION_CODES } from '../../../constants';
import { actions, selectors } from '../../../state';
import './recommended-providers.global.css';
import { trackEngagement } from '@mover-app/engagement';

const CLOUDINARY_URL = ENVIRONMENT.endpoints.cloudinary;

class RecommendedProvidersController {
  constructor(updStore) {
    'ngInject';
    Object.assign(this, {
      updStore,
      cloudinaryUrl: CLOUDINARY_URL,
    });
  }

  $onInit() {
    const { connect, dispatch } = this.updStore;

    trackEngagement({
      name: 'Local Guide',
      code: ITEM_DEFINITION_CODES.RECOMMENDED_PROVIDER,
    });
    dispatch(actions.preferredProvider.read());
    this.disconnect = connect(mapStateToThis)(this);
  }

  $onDestroy() {
    this.disconnect();
  }
}

export const RecommendedProvidersComponent = {
  template,
  controller: RecommendedProvidersController,
};

function mapStateToThis(state) {
  return {
    providers: selectors.preferredProvider.all(state).map(mapProvider(state)),
    loading: selectors.pending.match(actions.preferredProvider.isRead, state),
  };
}

function mapProvider(state) {
  return provider => ({
    name: provider.name(state),
    nickname: provider.nickname(state),
    logo_id: provider.logoId(state),
    title: provider.title(state),
    description: provider.description(state),
    detail: provider.detail(state),
    contact_detail: provider.contactDetail(state),
    phone: provider.phone(state),
    email: provider.email(state),
    link: provider.link(state),
  });
}
